<div observeVisibility [class.active]="playing | async" [class.reverse]="reverse" class="player mt-5">
  <div class="info">
    <span class="artist text-truncate">{{ attachment.performer }}</span>
    <span class="name text-truncate">{{ attachment.title || attachment.file_name }}</span>
    <div class="time"><!--{{ percentElapsed | async }}--></div>
    <div class="play-bar">
      <div class="bar" [ngStyle]="{ width: (percentElapsed | async) + '%' }"></div>
      <div (click)="onSeekAudio($event)" class="bar-clickable"></div>
    </div>
  </div>
  <div *ngIf="attachment?.thumb" class="hidden" (deferLoad)="Service.getThumbSrc(attachment)"></div>
  <div class="album-art">
    <img *ngIf="!attachment?.thumb || attachment.thumb?.file_uri_error; else noPrevew" loading="lazy" src="/assets/images/round.png" />
    <ng-template #noPrevew>
      <img
        *ngIf="!attachment?.thumb?.file_uri_error"
        (error)="loadImageAttachmentError($event, attachment)"
        loading="lazy"
        [src]="attachment.thumb?.file_uri"
      />
    </ng-template>
  </div>
  <div class="control-panel">
    <div class="play-bar-bg" [ngStyle]="{ width: (percentElapsed | async) + '%' }"></div>
    <!--<div class="size">{{appComponent.file_size_convert}}</div>-->
    <div class="controls">
      <button (click)="onRewind()" class="prev btn">
        <i-feather name="rewind"></i-feather>
      </button>

      <button *ngIf="isLoading" class="btn play">
        <i-feather class="spin" name="loader"></i-feather>
      </button>
      <button *ngIf="!(playing | async) && !isLoading" (click)="playAudio()" class="btn play">
        <i-feather name="play"></i-feather>
      </button>
      <button *ngIf="(playing | async) && !isLoading" (click)="pauseAudio()" class="btn pause">
        <i-feather name="pause"></i-feather>
      </button>
      <button (click)="onForward()" class="btn next">
        <i-feather name="fast-forward"></i-feather>
      </button>
    </div>
  </div>
</div>
